import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const FeatureFive = () => {
  const { t } = useLanguage();

  const features = [
    {
      category: t('features.featureFive.categories.professionals.category'),
      title: t('features.featureFive.categories.professionals.title'),
      subtitle: t('features.featureFive.categories.professionals.subtitle'),
      topics: [
        {
          icon: 'far fa-user-plus',
          title: t('features.featureFive.categories.professionals.topics.recruitment.title'),
          desc: t('features.featureFive.categories.professionals.topics.recruitment.desc'),
          link: '/servico/recrutamento-tech',
        },
        {
          icon: 'far fa-users-cog',
          title: t('features.featureFive.categories.professionals.topics.outsourcing.title'),
          desc: t('features.featureFive.categories.professionals.topics.outsourcing.desc'),
          link: '/servico/outsourcing',
        },
      ],
    },
    {
      category: t('features.featureFive.categories.software.category'),
      title: t('features.featureFive.categories.software.title'),
      subtitle: t('features.featureFive.categories.software.subtitle'),
      topics: [
        {
          icon: 'far fa-laptop-code',
          title: t('features.featureFive.categories.software.topics.systems.title'),
          desc: t('features.featureFive.categories.software.topics.systems.desc'),
          link: '/servico/sistemas-plataformas',
        },
        {
          icon: 'far fa-mobile-alt',
          title: t('features.featureFive.categories.software.topics.apps.title'),
          desc: t('features.featureFive.categories.software.topics.apps.desc'),
          link: '/servico/aplicativos',
        },
      ],
    },
    {
      category: t('features.featureFive.categories.infrastructure.category'),
      title: t('features.featureFive.categories.infrastructure.title'),
      subtitle: t('features.featureFive.categories.infrastructure.subtitle'),
      topics: [
        {
          icon: 'far fa-cloud-upload-alt',
          title: t('features.featureFive.categories.infrastructure.topics.migration.title'),
          desc: t('features.featureFive.categories.infrastructure.topics.migration.desc'),
          link: '/servico/migracao-cloud',
        },
        {
          icon: 'far fa-cogs',
          title: t('features.featureFive.categories.infrastructure.topics.management.title'),
          desc: t('features.featureFive.categories.infrastructure.topics.management.desc'),
          link: '/servico/gerenciar-otimizar',
        },
      ],
    },
    {
      category: t('features.featureFive.categories.ai.category'),
      title: t('features.featureFive.categories.ai.title'),
      subtitle: t('features.featureFive.categories.ai.subtitle'),
      topics: [
        {
          icon: 'far fa-brain',
          title: t('features.featureFive.categories.ai.topics.generative.title'),
          desc: t('features.featureFive.categories.ai.topics.generative.desc'),
          link: '/servico/ia-generativa',
        },
        {
          icon: 'far fa-robot',
          title: t('features.featureFive.categories.ai.topics.custom.title'),
          desc: t('features.featureFive.categories.ai.topics.custom.desc'),
          link: '/servico/ia-personalizada',
        },
      ],
    },
  ];

  return (
    <section className="feature-cards-section ptb-120">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10">
            <div className="section-heading text-center">
              <h2>{t('features.featureFive.title')} <span className="destaque">{t('features.featureFive.highlight')}</span> {t('features.featureFive.subtitle')}</h2>
            </div>
          </div>
        </div>
        <div className="row feature-cards-row justify-content-center mt-4 p-4">
          {features.map((feature, idx) => (
            <div className="col-md-6 col-xl-6 mb-4" key={idx}>
              <div className=" h-100 bg-gray p-4" style={{ backgroundColor: '#f8f9fa' }}>
                <span className="feature-card-category">• {feature.category}</span>
                <h3 className="feature-card-title destaque mt-2 mb-1">{feature.title}</h3>
                <p className="feature-card-subtitle mb-3">{feature.subtitle}</p>
                <ul className="feature-card-list list-unstyled">
                  {feature.topics.map((topic, tIdx) => (
                    <li className="d-flex align-items-start mb-3" key={tIdx}>
                      <i className={`feature-card-icon ${topic.icon} me-3 mt-1`} style={{ fontSize: '1.5rem', color: '#007bff' }}></i>
                      <div>
                        <strong>{topic.title}</strong>
                        <p className="mb-1">{topic.desc}</p>
                        <Link to={topic.link} className="feature-card-link">
                          {t('features.featureFive.categories.professionals.topics.recruitment.link')} 
                        </Link>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureFive;
